/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, status: NonNullable<unknown>, suffix: NonNullable<unknown> }} Orders_Bulk_Update_SuccessInputs */

const en_orders_bulk_update_success = /** @type {(inputs: Orders_Bulk_Update_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.count} order(s) to ${i?.status}${i?.suffix}`)
};

const es_orders_bulk_update_success = /** @type {(inputs: Orders_Bulk_Update_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se actualizaron ${i?.count} pedido(s) a ${i?.status}${i?.suffix}`)
};

/**
* | output |
* | --- |
* | "Updated {count} order(s) to {status}{suffix}" |
*
* @param {Orders_Bulk_Update_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_bulk_update_success = /** @type {((inputs: Orders_Bulk_Update_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Bulk_Update_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_bulk_update_success(inputs)
	return es_orders_bulk_update_success(inputs)
});